import { render } from "./UiSelectTooltip.vue?vue&type=template&id=bbe789f0&scoped=true"
import script from "./UiSelectTooltip.vue?vue&type=script&lang=js"
export * from "./UiSelectTooltip.vue?vue&type=script&lang=js"

import "./UiSelectTooltip.vue?vue&type=style&index=0&id=bbe789f0&lang=scss&scoped=true"
const cssModules = {}
import style1 from "./UiSelectTooltip.vue?vue&type=style&index=1&id=bbe789f0&lang=scss&module=true"
cssModules["$style"] = style1

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-bbe789f0"]])

export default __exports__